import { faEnvelope, faHeadphonesSimple, faMapMarkerAlt, faPhone, faQuestion, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useEffect, useRef } from 'react';
import { ObserverContext } from '../../Contexts/ObserverContext';

function Contact() {
   const ref = useRef();

  const { activeSection, setActiveSection } = useContext(ObserverContext);
  
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        // set value in context for section = team.
        setActiveSection('contact');
        console.log('this is updated section',activeSection)
      }
    });
    if (ref && ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return (
   <section className="contact-footer" id="contact" ref={ref}>
  <div className="container">
    <h2 className="footer-title">Contact Us</h2>
    <div className="footer-content">
      <div className="footer-item">
        <FontAwesomeIcon icon={faLocationDot} size="2x" />
        <h3>Address</h3>
        <p>Plot No. B-31, Industrial Area,<br />Phase-3, Mohali-160055</p>
        <p>9988901721 , 9988901739</p>
      </div>
      <div className="footer-item">
        <FontAwesomeIcon icon={faHeadphonesSimple} size="2x" />
        <h3>Sales</h3>
        <p>sales@accessinfotechindia.com</p>
      </div>
      <div className="footer-item">
        <FontAwesomeIcon icon={faQuestion} size="2x" />
        <h3>Information & Queries</h3>
        <p>info@accessinfotechindia.com</p>
      </div>
      <div className="footer-item">
        <FontAwesomeIcon icon={faEnvelope} size="2x" />
        <h3>Careers</h3>
        <p>careers@accessinfotechindia.com</p>
      </div>
    </div>
  </div>
</section>

    
  );
}

export default Contact;